import React from "react";
import { GovPagination } from "@gov-design-system-ce/react";
import { getDecodedUser } from "../../utils/login";

const getPageSizeOptions = () => {
  const roles = getDecodedUser().aut || [];
  if (
    roles.includes("ROLE_INTERNAL") ||
    roles.includes("ROLE_OVM") ||
    roles.includes("ROLE_LEGITIMATE")
  ) {
    return [10, 20, 50, 100, 1000];
  }
  return [10, 20, 50, 100];
};

const Summary = ({ count, pageSize, page, onPageChange, onPageSizeChange, showTotalCount, exportInSummary }) => {
  const safeCount = Number(count) || 0;
  const safePageSize = Number(pageSize) || 10;
  const safePage = Number(page) || 0;
  const totalPages = Math.max(1, Math.ceil(safeCount / safePageSize));
  const safeCurrent = Math.min(Math.max(safePage + 1, 1), totalPages);
  const paginationKey = `${safeCount}-${safePageSize}-${safeCurrent}`;
  const rangeStart = safePage * safePageSize + 1;
  const rangeEnd = Math.min((safePage + 1) * safePageSize, safeCount);

  if (!safeCount) return null;

  const handlePageSizeChange = (e) => {
    const newSize = Number(e.target.value);
    if (onPageSizeChange) onPageSizeChange(newSize);
    onPageChange(0);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
        rowGap: 8,
        margin: "4px 0",
      }}
    >
      {onPageSizeChange && (
        <>
          { showTotalCount &&
              <div style={{ flex: 1, fontWeight: 500, fontSize: 15, color: "#333" }}>{`Celkový počet záznamů: ${safeCount.toLocaleString("cs-CZ")}`}</div>
          }
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <label
              htmlFor="grid-page-size"
              style={{ fontSize: 14, color: "#555", whiteSpace: "nowrap" }}
            >
              Záznamů na stranu:
            </label>
            <select
              id="grid-page-size"
              value={safePageSize}
              onChange={handlePageSizeChange}
              style={{
                fontSize: 14,
                padding: "2px 6px",
                border: "1px solid #cfd8e3",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              {getPageSizeOptions().map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
            {/* <span style={{ fontSize: 14, color: "#555", whiteSpace: "nowrap" }}>
              Celkem: <b>{safeCount.toLocaleString("cs-CZ")}</b>
            </span> */}
          </div>
        </>
      )}
      <span style={{ fontSize: 14, color: "#555", whiteSpace: "nowrap" }}>
        {rangeStart} - {rangeEnd} z {safeCount.toLocaleString("cs-CZ")}
      </span>
      <GovPagination
        key={paginationKey}
        onPage={(p) => onPageChange(p - 1)}
        total={safeCount}
        pageSize={safePageSize}
        current={safeCurrent}
        maxPages={Math.min(5, totalPages)}
        accessibleSelectLabel="Vybrat stranu"
        type="button"
        color="primary"
        size="s"
        aria-label="Stránkování"
      />
    </div>
  );
};

export default Summary;
